import { AutocompleteType ,TextFieldType,DatePickerType} from "../../../../utilis/component/CustomFormElement"


type ProblemsFormDataType={
    icdDto:AutocompleteType,
    icdSnomedDto:AutocompleteType,
    lifeCycleStatusDto:AutocompleteType,
    Dateofonset:DatePickerType,
    resolvedDate:DatePickerType,
    notes:TextFieldType
}

export const ProblemsFormData:ProblemsFormDataType={

    icdDto:{
            element:"autocomplete",
            name:"icdDto",
            fieldProps:{label:"Diagnosis"},
            rules:{required:"Diagnosis Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.icdCode,
                isOptionEqualToValue: (option, value) => option.diagId == value.diagId,
              }
    },
    lifeCycleStatusDto:{
        element: "autocomplete",
        name: "lifeCycleStatusDto",
        fieldProps: {label: "status"},
        rules: {required: "Status required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.description,
            isOptionEqualToValue: (option, value) => option.id == value.id,
          }
    },
    icdSnomedDto:{
        element: "autocomplete",
        name: "icdSnomedDto",
        fieldProps: {label: "Problems",type:'text'},
        rules:{required:"Problems Required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.snomedDescription,
            isOptionEqualToValue: (option, value) => option.snomedId == value.snomedId,
          }
    },
    Dateofonset:{
        element: "datepicker",
        name: "dateOfOnset",
        fieldProps: { label: "Date of onset", type: 'date' },
        rules: { required: "Dateofonset Required" },
        dateFormat: "DD-MM-YYYY"
    },
    resolvedDate:{
        element: "datepicker",
        name: "resolvedDate",
        fieldProps: { label: "Resolved Date", type: 'date' },
        rules: { required: false },
        dateFormat: "DD-MM-YYYY"
    },
    notes:{
        element: "input",
        name: "notes",
        fieldProps: {label: "Notes",type:'text',multiline:true},
        rules:{required:false}
    },
}